import { Skeleton as SkeletonAntd, SkeletonProps as SkeletonPropsAntd } from 'antd'
import { ReactNode } from 'react'

interface SkeletonProps extends SkeletonPropsAntd {
  children?: ReactNode
  active?: boolean
}

export const Skeleton = ({ children, active = true, ...props }: SkeletonProps) => {
  return (
    <SkeletonAntd active={active} {...props}>
      {children}
    </SkeletonAntd>
  )
}
